import { ProductDetailsAddToCartV1, SelectItemProductDetailsClickV1, ProductDetailsPageHitV1 } from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

type Universe = 'WOMAN' | 'MAN' | 'KID';

export const PRODUCT_DETAILS_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
    productId?: string | number;
  };

  const productId = Number(payload?.productId);

  // A PRODUCT_DETAILS PageHit without a valid productId is invalid per the
  // Zenit #974 spec and would be dropped downstream. Skip emission instead of
  // sending NaN to the SDK.
  if (!Number.isFinite(productId)) {
    return undefined;
  }

  return buildEvent({
    Event: ProductDetailsPageHitV1,
    payload: {
      universe: normalizeUniverse(payload?.universe),
      productId,
    },
  });
};

export const SELECT_ITEM_PRODUCT_DETAILS_CLICK = ({ data }: { data?: unknown }) => {
  const payload = data as {
    listPosition?: number;
    productGroupId?: number | null;
    productId?: number;
    section?: string;
  };

  return buildEvent({
    Event: SelectItemProductDetailsClickV1,
    payload: {
      listPosition: Number(payload?.listPosition),
      productGroupId: payload?.productGroupId ?? null,
      productId: Number(payload?.productId),
      section: normalizeUniverse(payload?.section),
    },
  });
};

export const PRODUCT_DETAILS_ADD_TO_CART = ({ data }: { data?: unknown }) => {
  const payload = data as {
    cartId?: string | number | null;
    productId?: number;
  };

  const normalizedPayload = {
    // cartId is an opaque alphanumeric id, so coercing it with Number() yields
    // NaN. Forward it as a string (defaulting to "" when absent), matching the
    // other cart dispatchers in this codebase.
    cartId: payload?.cartId != null ? String(payload.cartId) : '',
    productId: Number(payload?.productId),
  };

  const event = buildEvent({
    Event: ProductDetailsAddToCartV1,
    payload: normalizedPayload as never,
  });

  return event;
};
